import { Dispatch } from 'react';


export const REGISTERED_EMAIL = "REGISTERED_EMAIL";


export const storeEmail = (email:string) => {
    return (dispatch: Dispatch<any>) => {

        dispatch({ type: REGISTERED_EMAIL, email });
    }
}
